import { render, staticRenderFns } from "./base-common-keyboard.vue?vue&type=template&id=18de934f&scoped=true&"
import script from "./base-common-keyboard.vue?vue&type=script&lang=js&"
export * from "./base-common-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./base-common-keyboard.vue?vue&type=style&index=0&id=18de934f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de934f",
  null
  
)

export default component.exports